var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJudiIconWhiteKnockout = function SvgJudiIconWhiteKnockout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-labelledby": "judi-icon-white-knockout",
    viewBox: "0 0 192 192"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96 0C42.997 0 0 42.997 0 96s42.997 96 96 96 96-42.997 96-96S149.003 0 96 0m-6.242 146.13H73.314a16.405 16.405 0 0 1-16.446-16.446 16.406 16.406 0 0 1 16.446-16.446h16.445zm6.638 0V80.248c18.13 0 32.892 14.761 32.892 32.891 0 18.229-14.762 32.991-32.892 32.991m32.892-54.984c-6.836-10.997-19.022-18.428-32.892-18.428V56.371a16.406 16.406 0 0 1 16.446-16.445 16.405 16.405 0 0 1 16.446 16.445z"
  })));
};
export default SvgJudiIconWhiteKnockout;